import React from "react";
import { Table, Avatar, Tag, Dropdown } from "antd";
import { MoreOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import SubtleBadge from "components/common/SubtleBadge";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";

// Colors for project status
const statusColors = {
  active: "#D1FAE5", // greenish
  inactive: "#FEE2E2", // red-ish
  archived: "#F3F4F6", // gray
};

const ProjectsListView = ({
  projects,
  openDetailsDrawer,
  openEditDrawer,
  onDelete
}) => {
  const navigate = useNavigate();

  console.log("Projects", projects);

  const columns = [
    {
      title: "Project",
      dataIndex: "name",
      key: "name",
      width: 250,
      render: (name, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar style={{ backgroundColor: "#87d068" }}>
            {name.charAt(0)}
          </Avatar>
          <a onClick={() => navigate(paths.projectDetails(record.id))}>
            {name}
          </a>
        </div>
      ),
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      width: 150,
    },
    {
      title: "Owner",
      dataIndex: "ownerName",
      key: "ownerName",
      width: 150,
    },
    {
      title: "Tasks",
      dataIndex: "taskCount",
      key: "taskCount",
      width: 80,
      render: (taskCount) => (
        <span>{taskCount || "—"}</span>
      ),
    },
    {
      title: "Iterations",
      dataIndex: "iterationCount",
      key: "iterationCount",
      width: 100,
      render: (iterationCount) => (
        <span>{iterationCount || "—"}</span>
      ),
    },
    {
      title: "Target Points",
      dataIndex: "targetPoints",
      key: "targetPoints",
      width: 120,
      render: (targetPoints) => (
        <span>{targetPoints || "—"}</span>
      ),
    },
    {
      title: "",
      key: "actions",
      width: 60,
      align: "right",
      render: (_, record) => {
        const items = [
          {
            key: "view",
            icon: <EyeOutlined />,
            label: "View",
            onClick: ({ domEvent }) => {
              domEvent.stopPropagation();
              openDetailsDrawer?.(record);
            },
          },
          {
            key: "edit",
            icon: <EditOutlined />,
            label: "Edit",
            onClick: ({ domEvent }) => {
              domEvent.stopPropagation();
              openEditDrawer(record);
            },
          },
          {
            key: "delete",
            icon: <DeleteOutlined />,
            label: "Delete",
            danger: true,
            onClick: ({ domEvent }) => {
              domEvent.stopPropagation();
              onDelete?.(record);
            },
          },
        ];

        return (
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <MoreOutlined
              style={{ fontSize: 16, cursor: "pointer", color: "#6b7280" }}
              onClick={(e) => e.stopPropagation()}
            />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <div className="projects-list-view">
      <Table
        columns={columns}
        dataSource={projects}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        expandable={{
          expandedRowRender: (record) => {
            return (
              <div
                style={{
                  padding: 12,
                  background: "#f9fafb",
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                {/* Full-width Description */}
                <div style={{ width: "100%" }}>
                  <strong>Description:</strong> {record.description || "—"}
                </div>

                {/* Two-column section for the rest */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    rowGap: 5,
                  }}
                >
                  <div style={{ flex: "1 1 45%" }}>
                    <strong>Tags:</strong>{" "}
                    {record.tags && record.tags.length > 0 ? (
                      record.tags.map((tag) => (
                        <span
                          key={tag.id}
                          color="blue"
                          style={{
                            background: "#DBEAFE",
                            color: "#000",
                            padding: 4,
                            paddingInline: 8,
                            borderRadius: 4,
                            marginRight: 5,
                          }}
                        >
                          {tag.name}
                        </span>
                      ))
                    ) : (
                      <span>—</span>
                    )}
                  </div>

                  <div style={{ flex: "1 1 45%" }}>
                    <strong>Owner:</strong> {record.ownerName}
                  </div>

                  <div style={{ flex: "1 1 45%" }}>
                    <strong>Iterations:</strong> {record.iterationCount}
                  </div>

                  <div style={{ flex: "1 1 45%" }}>
                    <strong>Tasks:</strong> {record.taskCount}
                  </div>
                </div>
              </div>
            );
          },
          rowExpandable: () => true,
        }}
        className="custom-table"
        size="small"
      />
    </div>
  );
};

export default ProjectsListView;
